import store from '@/store';
import {Action, getModule, Module, MutationAction, VuexModule} from 'vuex-module-decorators';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import { IConsumables, IConsumablesListItem } from '@/entity/consumables/consumables.types';
import { ServiceGeneralProductsCreateRequestType } from '@/form/serviceGeneral/serviceGeneralProductsCreate.types';
import { prepareFormData } from '@/store/utils/formDataHelper'

import {ResponseDataType} from "@/form/form.types";
import { ConsumablesTypeForm } from '@/form/serviceGeneral/serviceGeneralProductsCreate';

@Module({
    namespaced: true,
    name: 'consumables',
    store,
    dynamic: true
})

class ConsumableModule extends VuexModule{
    consumables: IConsumables | null = null;
    consumable:  IConsumablesListItem | null = null;
    consumableLoaded   = false;
    consumablesLoaded  = false;

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ consumables: IConsumables; consumablesLoaded: boolean }> {

        let consumablesLoaded = false;
        const consumables = await store.$repository.consumables.fetchAll(prepareFormData(data));
        if(consumables){
            consumablesLoaded = true;
        }
        return { consumables, consumablesLoaded}
    }

    @MutationAction
    async fetchData(data: PaginationRequestType): Promise<{ consumable: IConsumablesListItem; consumableLoaded: boolean }> {
        let consumableLoaded = false;
        const consumable = await store.$repository.consumables.fetchData(data);
        if (consumable) {
            consumableLoaded = true;
        }
        return { consumable, consumableLoaded};
    }

    @Action({rawError: true})
    async create(data: ConsumablesTypeForm): Promise<ResponseDataType> {
        console.log(data);
        const resp = await store.$repository.consumables.create(data);
        return resp;
    }
    @Action({rawError: true})
    async update(data: ServiceGeneralProductsCreateRequestType): Promise<ResponseDataType> {
        const resp = await store.$repository.consumables.update(data);
        return resp;
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        const resp = await store.$repository.consumables.delete(data);
        return resp;
    }
}

export const ConsumableStore = getModule(ConsumableModule);